<script>
import Vue from 'vue'
import {mapActions} from 'vuex'
import {COUNTRY_ARRIVO, FAKE_ACTIVE, WS_URL} from '../../utils/config'
import {SERVER_DATE_FORMAT} from '../../utils/formatter'
import {ERROR_GENERIC} from '../../utils/messages'
import response from '../../fake/experience-services-response'

export default {
  name: 'SearchExperienceServicesAction',
  methods: {
    ...mapActions(['loadingStart', 'loadingEnd']),
    searchExperienceServices (data) {
      return FAKE_ACTIVE ? this.searchExperienceServicesFake() : this.searchExperienceServicesReal(data)
    },
    searchExperienceServicesFake () {
      return new Promise((resolve) => {
        resolve(response)
      })
    },
    searchExperienceServicesReal (searchData) {
      let servizi = []
      searchData.servizi.forEach(obj => {
        servizi = servizi.concat(obj.services.map(item => {
          return {locationId: {countryCode: COUNTRY_ARRIVO, provider: item.fornitore.name, code: item.codice.trim()}, days: item.days}
        }))
      })
      const camere = searchData.search.camere.map(function (item, index) {
        return {id: index + 1, adults: item.adults, childs: item.childs}
      })
      const start = this.$moment(searchData.search.partenza).format(SERVER_DATE_FORMAT)
      const end = this.$moment(searchData.search.partenza).add('days', searchData.days).format(SERVER_DATE_FORMAT)
      const tours = searchData.tours
      const payload = {
        hotelPeriods: [[start, end]],
        travelGroup: camere,
        servizi,
        tours
      }
      return new Promise((resolve, reject) => {
        this.loadingStart()
        Vue.axios.post(`${WS_URL}experience/record`, payload, {withCredentials: true}).then(response => {
          const data = response.data
          if (!data.done && data.messages) {
            const error = {error: true, messages: data.messages}
            this.$toastr.error(data.messages[0].message)
            reject(error)
          } else {
            resolve(data)
          }
        }).catch((error) => {
          this.$toastr.error(ERROR_GENERIC)
          reject(error)
        }).finally(() => {
          this.loadingEnd()
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/actions/SearchExperienceServicesAction.vue